var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("交易管理")]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { name: "tradeInquire" } } },
                [_vm._v("交易查询")]
              ),
              _c("el-breadcrumb-item", [_vm._v("交易订单详情")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.orderTableLoading,
                  expression: "orderTableLoading",
                },
              ],
              attrs: {
                "show-summary": "",
                "summary-method": _vm.getSummaries,
                data: _vm.orderTableData,
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", prop: "title", label: "商品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "commodity-name-style" }, [
                          _c(
                            "div",
                            { staticClass: "commodity-wrap-img-style" },
                            [
                              _c("img", {
                                staticClass: "commodity-img-style",
                                attrs: { src: scope.row.coverImage, alt: "" },
                              }),
                              _c("span", [_vm._v(_vm._s(scope.row.title))]),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productPrice",
                  label: "商品价格",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.productPrice,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productSpec",
                  label: "商品规格",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", prop: "quantity", label: "商品数量" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "paymentAmount",
                  label: "商品定金",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.paymentAmount,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "levelDiscountAmount",
                  label: "级别折扣金额",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.levelDiscountAmount,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "orderAmount",
                  label: "商品总价",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                scope.row.orderAmount,
                                "元"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "hx-form-container box-shadow" }, [
        _c("p", { staticClass: "form-title" }, [_vm._v("订单信息")]),
        _c(
          "div",
          { staticClass: "form-details" },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.orderInfoForm } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "订单编号：" } }, [
                          _vm._v(" " + _vm._s(_vm.orderInfoForm.orderNo) + " "),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "下单日期：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.orderInfoForm.paymentDate,
                                  true
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "订单状态：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.orderInfoForm.orderStatusDisplay) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "支付状态：" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.orderInfoForm.paymentStatus) + " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "商品总金额：" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatToFixed2")(
                                    _vm.orderInfoForm.orderAmount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "订单定金：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatToFixed2")(
                                  _vm.orderInfoForm.paymentAmount
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "定金支付方式：" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.orderInfoForm.paymentType) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "保障级别名称：" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.orderInfoForm.levelName) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "级别折扣：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.orderInfoForm.levelDiscountRate) +
                              "折 "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "总折扣金额：" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatToFixed2")(
                                    _vm.orderInfoForm.totalDiscountAmount
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "hx-form-container box-shadow" }, [
        _c("p", { staticClass: "form-title" }, [_vm._v("收货信息")]),
        _c(
          "div",
          { staticClass: "form-details" },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.receivingInfoForm } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "收货人手机号码：" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.receivingInfoForm.buyerMobile) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c("el-form-item", { attrs: { label: "收货地址：" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.receivingInfoForm.logisticsSiteName) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _vm._m(0),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.cancelTableLoading,
                  expression: "cancelTableLoading",
                },
              ],
              staticStyle: { "margin-top": "20px" },
              attrs: { data: _vm.cancelTableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "商品", prop: "productTitle" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("img", {
                          staticStyle: { width: "100px", height: "100px" },
                          attrs: { src: row.productPicture, alt: "" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品名称",
                  prop: "productTitle",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品规格",
                  prop: "productSpec",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(row.productSpecWeight) +
                            "/" +
                            _vm._s(row.productSpec) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品数量",
                  prop: "productQuantity",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "商品单价",
                  prop: "productPrice",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "折扣率",
                  prop: "levelDiscountRate",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "核销金额",
                  prop: "tradeAmount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "核销退款状态",
                  prop: "showStatus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(" " + _vm._s(_vm.status[row.showStatus]) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "退款/补差",
                  prop: "fillOrRefundAmount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "折扣后单价",
                  prop: "discountPrice",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _vm._m(1),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { data: _vm.refundTableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "退款类型",
                  prop: "refundType",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatRefundType")(scope.row.refundType)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "退款原因", prop: "reason" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "退款金额",
                  prop: "refundAmount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "退款状态",
                  prop: "refundStatus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.refundStatus === 20
                          ? _c("span", { staticClass: "success" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatRefundStatus")(
                                      scope.row.refundStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : scope.row.refundStatus === 30
                          ? _c("span", { staticClass: "fail" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatRefundStatus")(
                                      scope.row.refundStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatRefundStatus")(
                                      scope.row.refundStatus
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewRefundDetail(scope.row.refundId)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款详情",
            visible: _vm.refundDetailDialogVisible,
            width: "650px",
            top: "15vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundDetailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.refundDetailLoading,
                  expression: "refundDetailLoading",
                },
              ],
            },
            [
              _vm.refundDetailData
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-width": "130px", size: "small" } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款记录ID：" } },
                            [_vm._v(_vm._s(_vm.refundDetailData.refundId))]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款金额：" } },
                            [
                              _vm._v(
                                _vm._s(_vm.refundDetailData.refundAmount) + "元"
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款类型：" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatRefundType")(
                                    _vm.refundDetailData.refundType
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款状态：" } },
                            [
                              _vm.refundDetailData.refundStatus === 20
                                ? _c("span", { staticClass: "success" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatRefundStatus")(
                                          _vm.refundDetailData.refundStatus
                                        )
                                      )
                                    ),
                                  ])
                                : _vm.refundDetailData.refundStatus === 30
                                ? _c("span", { staticClass: "fail" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatRefundStatus")(
                                          _vm.refundDetailData.refundStatus
                                        )
                                      )
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatRefundStatus")(
                                          _vm.refundDetailData.refundStatus
                                        )
                                      )
                                    ),
                                  ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "退款原因：" } },
                            [_vm._v(_vm._s(_vm.refundDetailData.reason))]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建时间：" } },
                            [_vm._v(_vm._s(_vm.refundDetailData.createdTime))]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "支付渠道：" } },
                            [
                              _vm._v(
                                _vm._s(_vm.refundDetailData.paymentChannel)
                              ),
                            ]
                          ),
                          _vm.refundDetailData.hasWechatResult
                            ? [
                                _c(
                                  "el-divider",
                                  { attrs: { "content-position": "left" } },
                                  [_vm._v("微信退款查询结果")]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "微信交易号：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData.wechatTransactionId
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退款金额(分)：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData.wechatRefundFee
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "订单总金额(分)：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData.wechatTotalFee
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退款笔数：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData.wechatRefundCount
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退款入账账户：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData
                                          .wechatRefundRecvAccout
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退款成功时间：" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData
                                          .wechatRefundSuccessTime
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "el-divider",
                                  { attrs: { "content-position": "left" } },
                                  [_vm._v("微信退款查询结果")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "fail",
                                    staticStyle: { "padding-left": "130px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.refundDetailData.message ||
                                          "未获取到微信退款详情"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "fail" }, [
                    _vm._v("暂无退款详情数据"),
                  ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form-title" }, [
      _c("span", [_vm._v("核销列表")]),
      _c("span", { staticStyle: { float: "right", "font-size": "16px" } }, [
        _vm._v("注：当前页面订单在列表中已标红"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "form-title" }, [
      _c("span", [_vm._v("退款列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }